import { LocationModel } from "./location.model";

export class JobSiteModel extends LocationModel {
  id: number;
  jobAddress: string;
  jobName: string;

  constructor(model?: Partial<JobSiteModel>) {
    super();
    Object.assign(this, model);
  }
}
